/**
 * Form helper utilities for song creation/update component
 */

import type { SongFormSchemaData } from "./songFormSchema";

// Type aliases for better type safety
type FormResetFunction = (data?: SongFormSchemaData | undefined) => void;
type SetSongDataFunction = (data: Partial<SongFormSchemaData>) => void;
type ClearStateFunction = () => void;
type SetErrorMessageFunction = (message: string) => void;

/**
 * Empty form data for resetting forms
 */
export const EMPTY_FORM_DATA: SongFormSchemaData = {
  title: "",
  durationMins: 0,
  durationSecs: 0,
  alternativeTitles: [],
  performingArtists: [],
  isRemix: false,
  containsSamples: false,
  writers: [],
};

/**
 * Empty song data for resetting store (includes Spotify data and recordings)
 */
export const EMPTY_SONG_DATA = {
  title: "",
  durationMins: 0,
  durationSecs: 0,
  alternativeTitles: [],
  performingArtists: [],
  isRemix: false,
  containsSamples: false,
  spotifyResult: null,
  spotifyURL: "",
  recordings: [],
};

/**
 * Reset form and store to empty state
 * This consolidates the repeated pattern of resetting both form and store data
 */
export function resetFormAndStore(
  formReset: FormResetFunction,
  setSongData: SetSongDataFunction,
  clearState: ClearStateFunction,
  setSpotifyLinkErrorMessage?: SetErrorMessageFunction,
): void {
  clearState(); // Clear Zustand store
  formReset(EMPTY_FORM_DATA); // Reset form
  setSongData(EMPTY_SONG_DATA); // Reset song data store

  // Clear Spotify error message if function provided
  if (setSpotifyLinkErrorMessage) {
    setSpotifyLinkErrorMessage("");
  }
}

/**
 * Clear error messages helper
 */
export function clearErrorMessages(
  setSpotifyLinkErrorMessage: SetErrorMessageFunction,
  setMutationErrorMessage?: SetErrorMessageFunction,
  setValidationErrorMessage?: SetErrorMessageFunction,
): void {
  setSpotifyLinkErrorMessage("");
  if (setMutationErrorMessage) {
    setMutationErrorMessage("");
  }
  if (setValidationErrorMessage) {
    setValidationErrorMessage("");
  }
}
